import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

export type MessageDriverSupportPayload = {
  message: string;
  regardingOpportunityId?: string;
  pageUrl: string;
};

export const messageDriverSupport = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { defaultOnMutateSuccess } = useAPQuery();

  return useMutation({
    mutationFn: (payload: MessageDriverSupportPayload) => {
      return fetchWithAuth("messageDriverSupport", undefined, {
        requestOptions: {
          method: "post",
          body: JSON.stringify(payload),
        },
      });
    },
    onMutate: defaultOnMutateSuccess(options),
  });
};
